import React, { useEffect } from "react";
import queryString from "query-string";
import LoadingScreen from "./LoadingScreen";

const UgcSuitTiktok = () => {
    const parsed = queryString.parse(window.location.search);
    useEffect(() => {
        if (parsed && Object.keys(parsed).length > 0) {
            const { state, code } = parsed;
            let url = "#";
            if (state.includes('staging')) url = `https://creators-test.taggbox.com/tiktok/authCallback?code=${code}&state=tiktok`;
            else url = `https://creators.taggbox.com/tiktok/authCallback?code=${code}&state=tiktok`;
            window.location.href = url;
        }
    }, [])
    return <LoadingScreen />
}

export default UgcSuitTiktok;